import {IApplicationState} from '../../../../../../types/types';
import { filterPanelBoardsSelector } from './filterPanelBoardsSelector';

export const filterPanelIsEnabledSelector = (
    state: IApplicationState,
    boardId: number
): boolean => {
    return filterPanelBoardsSelector(state, boardId).isEnabled
};
